import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export interface BreadcrumbItem {
  // `AwBreadcrumbVersion2` feeds this straight into `$localePath()`, which takes a `RouteLocationRaw` —
  // most callers pass a path or route-name string, the sticker details page passes a `{name, params}` object.
  token: string,
  /** Path, route name or route location object; may be missing on a level that has no target. */
  to?: RouteLocationRaw,
  /** Renders the level as plain text instead of a link. */
  disabled?: boolean,
  categoryId?: number | string,
}

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
  const breadcrumbs = ref<BreadcrumbItem[]>([]);

  function setBreadcrumbs (newBreadcrumbs: BreadcrumbItem[]) {
    breadcrumbs.value = newBreadcrumbs;
  }

  return {
    breadcrumbs,
    setBreadcrumbs,
  };
});
